import { COMPANY } from "../lib/company";

/**
 * The Simino Social glyph. Served from `public/` rather than imported, so the URL is
 * identical in the client bundle and in the pre-render — a hashed asset name would
 * differ between the two builds and 404 in the pre-rendered HTML.
 */
export function BrandMark({ className = "site-mark" }: { className?: string }) {
  return <img src="/mark.png" className={className} alt="" width={26} height={26} aria-hidden="true" />;
}

/** Glyph plus wordmark, used in the header, the footer and the signed-in nav. */
export function BrandLockup() {
  return (
    <>
      <BrandMark />
      <span>{COMPANY.product}</span>
    </>
  );
}
